











import {formatNumber, moneyValue} from '@/components/charts/numbers';
import Vue, {PropType} from 'vue';

export default Vue.extend({
        props: {
            name: {
                type: String,
            },
            amount: {
                type: Number as PropType<number | null>,
            },
            currency: {
                type: String,
            },
        },

        methods: {
            format(amount: number, currency: string) {
                return moneyValue(amount, navigator.language, currency);
            },
        },
    });
